import * as chosen from 'chosen-js'; // eslint-disable-line no-unused-vars

document.addEventListener('DOMContentLoaded', () => {
  const universityList = $('.university-select');
  const form = universityList.closest('form')[0];
  form.addEventListener('submit', (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    const redirectUrl = universityList.find('option:selected').data('redirect');
    if (redirectUrl) {
      ev.target.querySelectorAll('button').forEach((el) => (el.disabled = true));
      window.location = redirectUrl;
    }
  });
  universityList.chosen({
    inherit_select_classes: true
  });

  universityList.on('chosen:showing_dropdown', function (evt, params) {
    $(this).siblings('.chosen-container').attr('aria-expanded', 'true');
    $('.chosen-results li').attr('tabindex', '0');
  });

  universityList.on('chosen:hiding_dropdown', function (evt, params) {
    $(this).siblings('.chosen-container').attr('aria-expanded', 'false');
    $(this).siblings('label').append("<span class='sr-only'>Start typing to search then use your keyboard navigate</span>");
  });

  $('.chosen-container').attr('role', 'combobox');
  $('.chosen-container').attr('aria-expanded', 'false');

  $('.chosen-search-input').each(function () {
    let label = $(this).closest('.chosen-container').siblings('.chosen-select').data('label') || 'Search';
    $(this).attr('aria-label', label);
    $(this).on('keyup', function (){
      const inputLabel = $('#university-select-label');
      let results = $('.chosen-results li.active-result').length;
      let matchCount = $(`span#count-for-${inputLabel.attr('for')}`);
      if(matchCount.length > 0){
        matchCount.text(`There are ${results} results available`);
      }else{
        inputLabel.append(`<span id='count-for-${inputLabel.attr('for')}' tabindex="-1" class='sr-only'>There are ${results} results available</span>`);
      }
    });
  });

  $('.search-choice-close').each(function () {
    let optionText = $(this).siblings('span').text();
    $(this).attr('aria-label', 'Remove ' + optionText);
    $(this).attr('href', '#');
  });
});
